// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*:host {*/
/*    display: inline-flex;*/
/*    align-items: center;*/
/*}*/

div {
    align-items: center;
    background: var(--background-secondary);
    display: flex;
    min-height: var(--spacing-55);
    /*padding-left: var(--spacing-25);*/
    padding: 0 var(--spacing-25);
    max-height: 50vh;
    overflow: auto;
}

label {
    font-family: var(--p2-regular-font-family);
    font-size: var(--p2-regular-font-size);
    letter-spacing: var(--p2-regular-letter-spacing);
    line-height: var(--p2-regular-line-height);
    font-weight: var(--p2-regular-font-weight);
    margin: var(--spacing-10) var(--spacing-05);
}

:host([state="info"]) > div {
    background: var(--background-medium);
}
:host([state="error"]) > div {
    background: var(--background-error-light);
}
:host([state="success"]) > div {
    background: var(--background-success);
}
:host([state="warning"]) > div {
    background: var(--background-warning);
}
`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/banner/style/index.css"],"names":[],"mappings":"AAAA,UAAU;AACV,4BAA4B;AAC5B,2BAA2B;AAC3B,IAAI;;AAEJ;IACI,mBAAmB;IACnB,uCAAuC;IACvC,aAAa;IACb,6BAA6B;IAC7B,mCAAmC;IACnC,4BAA4B;IAC5B,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,0CAA0C;IAC1C,sCAAsC;IACtC,gDAAgD;IAChD,0CAA0C;IAC1C,0CAA0C;IAC1C,2CAA2C;AAC/C;;AAEA;IACI,oCAAoC;AACxC;AACA;IACI,yCAAyC;AAC7C;AACA;IACI,qCAAqC;AACzC;AACA;IACI,qCAAqC;AACzC","sourcesContent":["/*:host {*/\n/*    display: inline-flex;*/\n/*    align-items: center;*/\n/*}*/\n\ndiv {\n    align-items: center;\n    background: var(--background-secondary);\n    display: flex;\n    min-height: var(--spacing-55);\n    /*padding-left: var(--spacing-25);*/\n    padding: 0 var(--spacing-25);\n    max-height: 50vh;\n    overflow: auto;\n}\n\nlabel {\n    font-family: var(--p2-regular-font-family);\n    font-size: var(--p2-regular-font-size);\n    letter-spacing: var(--p2-regular-letter-spacing);\n    line-height: var(--p2-regular-line-height);\n    font-weight: var(--p2-regular-font-weight);\n    margin: var(--spacing-10) var(--spacing-05);\n}\n\n:host([state=\"info\"]) > div {\n    background: var(--background-medium);\n}\n:host([state=\"error\"]) > div {\n    background: var(--background-error-light);\n}\n:host([state=\"success\"]) > div {\n    background: var(--background-success);\n}\n:host([state=\"warning\"]) > div {\n    background: var(--background-warning);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
